import { DDSBodyText, DDSHeadlineText } from "@web-monorepo/dds";
import { useEffect } from "react";
import logEvent from "src/utils/logEvent";
import styles from "./TodayResult.module.css";

type Props = {
  title: string;
  text?: string;
};

export default function TodayResult({ title, text }: Props) {
  useEffect(() => {
    logEvent({ eventName: "morning.result.open" });
    return () => {
      logEvent({ eventName: "morning.result.close" });
    };
  }, []);

  return (
    <article className={styles.card}>
      <DDSHeadlineText as="h1" level="sm" className={styles.title}>
        {title}
      </DDSHeadlineText>
      <DDSBodyText as="p">{text}</DDSBodyText>
    </article>
  );
}
